/**
 * Feature flags for Trading Arena.
 *
 * TRADING_ARENA_DEPRECATED: Trading Arena is deprecated. When on, the app shows a
 * deprecation banner and blocks new agent creation. Existing agents, the dashboard,
 * leaderboard, and strategy pages remain viewable.
 *
 * Defaults to ON. Set NEXT_PUBLIC_TRADING_ARENA_DEPRECATED=false to turn it off.
 * NEXT_PUBLIC_* values are inlined at build time, so changing it requires a rebuild.
 */
export const TRADING_ARENA_DEPRECATED =
  process.env.NEXT_PUBLIC_TRADING_ARENA_DEPRECATED !== 'false';
